import { DialogTitle as NuiDialogTitle } from '@lsy-netline-ui/netline-ui';
import { DialogTitleProps as NuiDialogTitleProps } from '@lsy-netline-ui/netline-ui/DialogTitle';

const DialogTitle = (props: NuiDialogTitleProps) => <NuiDialogTitle data-test-id="dialog-title" {...props} />;

export default DialogTitle;
